"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorReducer = exports.editorState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immer = _interopRequireDefault(require("immer"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var editorState = {
  site: null,
  post: null,
  siteHasChanged: false,
  postHasChanged: false
};
exports.editorState = editorState;

var editorReducer = function editorReducer(state, action) {
  var payload = action.payload;
  return (0, _immer.default)(state, function (draft) {
    switch (action.type) {
      /******************************
       * Sites
       ******************************/
      case "ADD_EDITOR_SITE":
        draft.site = payload;
        draft.siteHasChanged = false;
        break;

      case "UPDATE_EDITOR_SITE":
        draft.site = _objectSpread(_objectSpread({}, draft.site), payload);
        draft.siteHasChanged = true;
        break;

      /******************************
       * Posts
       ******************************/

      case "ADD_EDITOR_POST":
        draft.post = payload;
        draft.postHasChanged = false;
        break;

      case "UPDATE_EDITOR_POST":
        draft.post = _objectSpread(_objectSpread({}, draft.post), payload);
        draft.postHasChanged = true;
        break;

      /******************************
       * General Settings
       ******************************/

      case "CLEAR_EDITOR":
        draft.site = null;
        draft.siteHasChanged = false;
        draft.post = null;
        draft.postHasChanged = false;
        break;

      default:
    }
  });
};

exports.editorReducer = editorReducer;